module.exports = __webpack_public_path__ + "static/media/bg-icon-2.ec54865c.png";